import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

interface Props {
    leftText?: string;
    rightText?: string;
    checked?: boolean;
    setChecked?: (v: boolean) => void;
    canDisabled?: boolean;
}

function Switch({
    leftText, rightText, checked, setChecked, canDisabled,
}:Props) {
    const isDisabled = canDisabled && (!checked);
    return (
        <Row spacing={8}>
            {leftText && (
                <Text color={colors.gray7}
                    fontWeight={checked ? 'regular' : 'bold'}
                >
                    {leftText}
                </Text>
            )}
            <div className={`${styles.container} ${isDisabled && styles.disabled} ${checked ? styles.checked : ''}`}
                onClick={() => setChecked?.(!checked)}>
                <div className={`${styles.handle} ${checked ? styles.checked : ''}`} />
            </div>
            {rightText && (
                <Text color={colors.gray7}
                    fontWeight={checked ? 'bold' : 'regular'}
                >
                    {rightText}
                </Text>
            )}
        </Row>
    );
}

export default Switch;
